/**
 * Return unique item by from a given id property from a given collection of objects
 * @param data - collection of objects to be filtered
 * @param id - property string used to find unique items within collection
 * @returns - an a unique object by id property
 */
export function findUniqueItemById(data: Array<object>, id: number): any {
  const property_id = 'id';
  return id && data && data.find((item) => item[property_id] === id);
}

/**
 * Return key from a given collection of objects to be filtered by a given value
 * @param object - collection of objects to be searched
 * @param value - value to find the matching key within the collection of objects
 * @returns - key that is found by the matching value within the collection
 */
export function getKeyByValue(object: any, value: string): any {
  return value && object && object.filter(({ 1: v }) => v === value).map(([k]) => k);
}
